export const upperCaseFirstLetter = (text: string) => {

  if (!!text) {
    return text.charAt(0).toUpperCase() + text.slice(1);
  }

  return text;
};
